/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import { getLoadout } from "../Fixture_combatants.js";
import BattleActions from "../battle/battle-data/battle-actions.js";
import {
  getNextLoadout,
  changeEditingCombatantValue
} from "./edit-combatant-operations";
import {getClassIcon} from '../b5-home/get-class-icon'

class EditCombatantLoadout extends React.Component {
  handleNextClick(e) {
    e.preventDefault();
    changeEditingCombatantValue(
      "combatantLoadoutId",
      getNextLoadout(this.props.combatantLoadoutId, "next")
    );
  }
  handlePrevClick(e) {
    e.preventDefault();
    changeEditingCombatantValue(
      "combatantLoadoutId",
      getNextLoadout(this.props.combatantLoadoutId, "prev")
    );
  }

  render() {
    const groupStyle = {
      marginBottom: "1em"
    };
    const labelStyle = {
      fontSize: "0.8em",
      display: "block",
      textAlign: "center",
      color: "#9D91A4",
      marginBottom: "0.5em"
    };
    const rowStyle = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "6em" //prevent the size of this guy from changing
    };

    const listsContainerStyle = {
      display: "flex",
      paddingTop: "2em",
      paddingBottom: "2em",
      height: "15em" //prevent the size of this guy from changing
    };
    const listStyle = {
      width: "50%"
    };
    const listTitleStyle = {
      marginBottom: "1.5em"
    };

    const loadoutTitleStyle = {
      textTransform: "uppercase",
      fontSize: "0.9em",
      lineHeight: "1.4em",
      textAlign: "center",
      display: "flex",
      alignItems: "center"
    };

    //Look up my loadoutModel Model
    const loadoutModel = getLoadout(this.props.combatantLoadoutId);
    if (!loadoutModel) {
      console.warn(
        "my loadoutModel not found",
        this.props.combatantLoadoutTitle,
        this.props.combatantLoadoutId
      );
    }

    const attackNames = loadoutModel.attacks.map(atk => {
      const model = BattleActions[atk.actionId];
      return {
        name: model.name,
        isSuper: model.isSuper
      };
    });
    const itemNames = loadoutModel.items.map(atk => {
      const model = BattleActions[atk.actionId];
      return {
        name: model.name
      };
    });

    const blipStyle = {
      marginBottom: "1em",
      fontSize: "0.85em"
    };

    return (
      <div style={groupStyle}>
        <div style={rowStyle}>
          <a
            className="button small"
            href="#"
            onClick={this.handlePrevClick.bind(this)}
          >
            <span className="button--text button--text_left-arrow-nudge">
              {"<"}
            </span>
          </a>

          <div>
            <label style={labelStyle}>Class</label>
            <div style={loadoutTitleStyle}>
              {getClassIcon(loadoutModel.class, "2.4em", {
                marginRight: "1em"
              })}
              {loadoutModel.loadoutTitle}
            </div>
          </div>

          <a
            className="button small"
            href="#"
            onClick={this.handleNextClick.bind(this)}
          >
            <span className="button--text button--text_right-arrow-nudge">
              {">"}
            </span>
          </a>
        </div>
        <div style={listsContainerStyle}>
          <div style={listStyle}>
            <div style={listTitleStyle}>ATTACKS</div>
            {attackNames.map((model, index) => {
              //"isSuper" is available to you here, if you want it.
              return (
                <div style={blipStyle} key={index}>
                  * {model.name}
                </div>
              );
            })}
          </div>
          <div style={listStyle}>
            <div style={listTitleStyle}>ITEMS</div>
            {itemNames.map((model, index) => {
              return (
                <div style={blipStyle} key={index}>
                  * {model.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default EditCombatantLoadout;



// WEBPACK FOOTER //
// ./src/b5-crew-management/EditCombatantLoadout.js